<template>
    <div>
        <button class="btn btn-link" @click="create" v-if="$hasPermission('requests.profiles.create')"><i class="fas fa-plus"></i> Создать</button>

        <template v-for="profile in profiles">
            <ProfileListItem :profile_model="profile"/>
        </template>
    </div>
</template>

<script>
    import ProfileListItem from "./ProfileListItem";
    export default {
        name: "ProfilesBlock",
        components: {ProfileListItem},
        props: ['request'],
        data: () => ({
            profiles: [],
        }),
        mounted() {
            this.profiles = this.request.profiles;
        },
        methods: {
            create() {
                let self = this;
                ((this.profiles.length > 0) ? this.$confirm('Создать новую анкету?', {confirmButtonText: 'Да', cancelButtonText: 'Нет',}) : new Promise((resolve) => {resolve()}))
                .then(function () {
                    self.profiles.push({
                        request_id: self.request.id,
                        data: {
                            title: "Анкета от " + moment().format('YYYY-MM-DD'),
                            contact_persons: [],
                            current_loans_isset: false,
                            family_status: "single",
                            job_isset: false,
                            driving_license_isset: true,
                            ldu_isset: false,
                            photo_client: [],
                            passport_scans: [],
                            driving_license_scans: [],
                            ldu_driving_license_scans: [],
                            ldu_passport_scans: [],
                            other_documents_scans: [],
                            agreements_scans: [],

                            car: [self.request.car_brand_name, self.request.car_model_name, self.request.car_modification_name, self.request.car_complete_name].join(" ").trim(),
                            car_year: self.request.car_year,
                            car_cost: self.request.car_cost,
                            credit_initial_payment: self.request.credit_initial_payment,
                            credit_term: self.request.credit_term,
                            last_name: self.request.last_name,
                            first_name: self.request.first_name,
                            middle_name: self.request.middle_name,
                            birthdate: self.request.birthdate,
                        }
                    });
                })
                .catch(function () {

                });
            }
        },
    }
</script>

<style scoped>

</style>
